// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3a953","calendarButtons":"ClockData_calendarButtons__2o8ik"};